class Node {
  constructor(nodeObj = {}) {
    if (!nodeObj.next || nodeObj.next.length === 0 ) {
      console.error('All nodes require a next action.');
    }

    const hasDefault = nodeObj.next.some((nextObj) => {
      return (nextObj.view || nextObj.action) && !nextObj.condition;
    })
    if (!hasDefault) {
      console.error('All nodes require a default action.');
      return;
    }

    this.self = nodeObj;
  }

  handleResponse(response, state) {
    let next;
    this.self.next.some((nextObj) => {
      next = nextObj;
      const conditionString = nextObj.condition;
      if (!conditionString) {
        return true;
      } else {
        const conditionFunc = new Function('response', 'state', `return ${conditionString}`);
        try {
          return conditionFunc(response, state);
        } catch (e) {
          return false;
        }
      }
    });
    delete next.condition;

    return next;
  }
}

export default class Config {
  constructor(configObj) {
    this.nodes = {};

    Object.keys(configObj.actions).forEach((key) => {
      const action = configObj.actions[key];
      const node = new Node(action);
      this.nodes[key] = node;
    });
  }

  getNextNode(lastNodeKey, response, state) {
    return this.nodes[lastNodeKey].handleResponse(response, state);
  }
}



/** WEBPACK FOOTER **
 ** ./src/_shared/lib/config-parser/index.js
 **/